import React, {useEffect, useMemo, useState} from "react";
import {EVALUATION_REPORT_LIST_HEADER} from "../../../../components/table/header/Headers";
import {handleActiveError, handleActiveToast} from "../../../../components/sonner/ToastBasic";
import {removeEvaluationReport} from "../../../../api/evaluation/ReportService";
import {getIndividualSetting, resetIndividualSetting, setIndividualSetting} from "../../../../api/user/UserAccountService";
import {extractObject, initHeaderOrders, simmsColumnsToJsGridHeaders} from "../../../../components/commonmethod/CommonMethod";
import {ToolbarDataTransfer} from "@bavuchoko/js-grid";
import SimmsJsGrid from "../../../../components/js-grid/SimmsJsGrid";
import {navigateWithChildTab, pickDetailTabTitle} from "../../../../components/pageTabs/pageTabsStorage";
import {useNavigate} from "react-router-dom";
import {useExcelDownloadClick} from "../../../../components/commonmethod/excelMethod";
import JsGridExcelGridOpenButton from "../../../../components/js-grid/JsGridExcelGridOpenButton";

function EvaluationReportListType({
    data,
    pageInfo,
    type,
    dataHook,
    deleteMessage,
}) {
    const navigate = useNavigate();
    const {saveConditions, handleGridPageChange} = dataHook;
    const handleDownloadClick = useExcelDownloadClick(saveConditions);

    const [header, setHeader] = useState({order: EVALUATION_REPORT_LIST_HEADER, exclude: []});

    useEffect(() => {
        getIndividualSetting().then((r) => {
            initHeaderOrders(r, EVALUATION_REPORT_LIST_HEADER, setHeader, [], () => {}, () => {}, 'evaluation');
        });
    }, []);

    const handleRowClick = (row) => {
        const id = row?.id;
        if (id == null) return;
        navigateWithChildTab(navigate, {
            title: pickDetailTabTitle(row, "종합보고서"),
            url: `/evaluation/report/${type}/${id}`,
        });
    };

    const deleteReport = async (rows) => {
        if (!rows?.length) {
            handleActiveToast({message: deleteMessage ?? "삭제할 보고서를 선택해주세요."});
            return;
        }
        if (!window.confirm("삭제하시겠습니까?")) {
            return;
        }
        const ids = rows.map((row) => row.id).filter((id) => id != null);
        const response = await removeEvaluationReport({ids});
        if (response.status === 200) {
            handleActiveToast({message: "데이터가 삭제되었습니다"});
            dataHook.refresh?.();
        } else if (response.status === 403) {
            handleActiveError({message: "권한이 없습니다."});
        } else {
            handleActiveError({message: "알 수 없는 에러 발생."});
        }
    };

    const evaluationJsGridHeader = useMemo(() => simmsColumnsToJsGridHeaders(header), [header]);
    const excelGridSearch = useMemo(() => extractObject(saveConditions), [saveConditions]);

    return (
        <div className="container-height-body">
            <SimmsJsGrid
                    loading={dataHook.loading}
                resizable={true}
                data={data}
                theme={'linear'}
                style={{minHeight: 0, height: '100%'}}
                header={evaluationJsGridHeader}
                onHeaderSave={(v) => setIndividualSetting({headers: {evaluation: v}})}
                onHeaderReset={() => resetIndividualSetting('headers', 'evaluation')}
                enableRowSelection={true}
                onRowClick={handleRowClick}
                onPageChange={handleGridPageChange}
                toolbarEnd={() => (
                    <div className="flex items-center gap-2">
                        <JsGridExcelGridOpenButton entityName="ExcelEvaluationReportDto" search={excelGridSearch} />
                        <ToolbarDataTransfer
                            hint="선택 항목 삭제"
                            busyHint="삭제 중…"
                            overlayLabel="삭제 중…"
                            onTransfer={deleteReport}
                        >
                            {(ctx) => (
                                <button
                                    type="button"
                                    className="text-[13px] px-3 py-0.5 text-black rounded-4 border disabled:cursor-not-allowed"
                                    onClick={() => {
                                        if (ctx.selectedCount === 0) {
                                            handleActiveToast({message: deleteMessage ?? "삭제할 보고서를 선택해주세요."});
                                            return;
                                        }
                                        void ctx.transferSelected();
                                    }}
                                >
                                    삭제
                                </button>
                            )}
                        </ToolbarDataTransfer>
                        <button
                            type="button"
                            className="text-[13px] px-3 py-0.5 border text-white bg-themeDark rounded-4"
                            onClick={() => navigate(`/evaluation/report/create/${type}`)}
                        >
                            등록
                        </button>
                    </div>
                )}
            />
        </div>
    );
}

export {EvaluationReportListType};
